import { XIcon } from 'lucide-react'

import { BottomSheet } from 'components/BottomSheet'
import { Button } from 'slab'

export const BottomSheetWithHeaderAndFooter: React.FC<React.PropsWithChildren<{
  title: React.ReactNode;
  footer: React.ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}>> = ({ title, footer, children, open, onOpenChange }) => {
  return (
    <BottomSheet
      open={open}
      onOpenChange={onOpenChange}
    >
      <div className='body-bold text-gray-800 border-b-[1px] p-4 bg-gray-50 absolute top-0 left-0 right-0 z-10'>
        <div className='flex items-center justify-between'>
          {title}
          <Button variant='tertiary-deemphasized' onClick={() => onOpenChange(false)}>
            <XIcon />
          </Button>
        </div>
      </div>
      <div className='flex-1 py-20 px-4'>{children}</div>
      <div className='border-t-[1px] p-4 bg-gray-50 absolute bottom-0 left-0 right-0'>{footer}</div>
    </BottomSheet>
  )
}
